import { createSlice } from "@reduxjs/toolkit";
import { getNearMiss } from "../reduxApi/nearMissRedusApi";
import { getNonSolarItemApi, getNonSolarItemCountApi } from "../reduxApi/NonSolarItemApi";

const NonSolarItemSlice = createSlice({
  name: "NonSolarItem",
  initialState: {
    status: "idel",
    getNonSolarItem: [],
    getNonSolarItemCount: [],
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getNonSolarItemApi.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getNonSolarItemApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // console.log("testing nearmiss Data", action.payload);
        state.getNonSolarItem = action.payload.data.queryResponse;
      })
      .addCase(getNonSolarItemCountApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // console.log("testing nearmiss Data", action.payload);
        state.getNonSolarItemCount = action.payload.data.count;
      });
  },
});

export default NonSolarItemSlice.reducer;
